"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productInquiry = void 0;
var qs = require('qs');
exports.productInquiry = function (axios) {
    return {
        getProductInquiriesDelayedCount: function (getProductInquiriesDelayedCountRequest) {
            return axios.get('/product-inquiries/delayed/count', getProductInquiriesDelayedCountRequest);
        },
        getProductInquiriesSummary: function (getProductInquiriesSummary) {
            return axios.get('/product-inquiries/summary', getProductInquiriesSummary);
        },
        getProductInquiriesDelayedCountPartnerAlarm: function () {
            return axios.get('/product-inquiries/delayed/count/partner-alarm');
        },
        getProductInquiries: function (getProductInquiriesRequest) {
            return axios.get('/product-inquiries', getProductInquiriesRequest);
        },
        getProductInquiriesByInquiryNo: function (_a) {
            var _b = _a.params, inquiryNo = _b.inquiryNo, hasProductName = _b.hasProductName;
            return axios.get("/product-inquiries/" + inquiryNo, { params: { hasProductName: hasProductName } });
        },
        getProductInquiriesConfigurations: function (getProductInquiriesRequestConfigurations) {
            return axios.get('/product-inquiries/configurations', getProductInquiriesRequestConfigurations);
        },
        deleteProductInquiriesByInquiryNo: function (_a) {
            var _b = _a.params, inquiryNo = _b.inquiryNo, mallNo = _b.mallNo;
            return axios.delete("/product-inquiries/" + inquiryNo, { params: { inquiryNo: inquiryNo, mallNo: mallNo } });
        },
        postProductInquiriesReplay: function (_a) {
            var inquiryNo = _a.params.inquiryNo, data = _a.data;
            return axios.post("/product-inquiries/" + inquiryNo + "/reply", data);
        },
        getProductInquiriesExcel: function (getProductInquiriesExcelRequest) {
            return axios.get('/product-inquiries/excel', getProductInquiriesExcelRequest);
        },
        putProductInquiriesByInquiryNo: function (_a) {
            var data = _a.data;
            return axios.put("/product-inquiries/" + data.inquiryNo + "/display-status", data);
        },
        putProductInquiriesSecretByInquiryNo: function (_a) {
            var data = _a.data;
            return axios.put("/product-inquiries/" + data.inquiryNo + "/secret", data);
        },
        putProductInquiriesConfigurations: function (putProductInquiriesConfigurationsRequest) {
            return axios.put("/product-inquiries/configurations?mallNo=" + putProductInquiriesConfigurationsRequest.params.mallNo, putProductInquiriesConfigurationsRequest.data);
        },
        getProductInquiriesMemberSummaries: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/product-inquiries/member-summaries?" + query);
        }
    };
};
